function queueTimestamp(value) {
  return new Date(value || 0).getTime();
}

function previewText(value) {
  const text = String(value || "").replace(/\s+/g, " ").trim();
  return text.length > 96 ? `${text.slice(0, 96)}...` : text;
}

function promptMode(value) {
  return value === "plan" ? "plan" : "edit";
}

export function isQueuedPromptRun(run) {
  if (!run || !["queued", "running"].includes(run.status || "")) return false;
  if (run.cancel_requested_at) return false;
  if (run.progress_stage === "canceling") return false;
  return true;
}

export function sortPendingPromptRuns(runs = []) {
  return [...runs]
    .filter(isQueuedPromptRun)
    .sort((a, b) => {
      const statusPriority = (run) => (run.status === "running" ? 0 : 1);
      const priorityDelta = statusPriority(a) - statusPriority(b);
      if (priorityDelta !== 0) return priorityDelta;
      const timeDelta = queueTimestamp(a.created_at) - queueTimestamp(b.created_at);
      if (timeDelta !== 0) return timeDelta;
      return String(a.id).localeCompare(String(b.id));
    });
}

export function resolvePrimaryPromptRun(runs = []) {
  return sortPendingPromptRuns(runs)[0] || null;
}

export function promptQueueSummary(runs = []) {
  const pendingRuns = sortPendingPromptRuns(runs);
  const runningCount = pendingRuns.filter((run) => run.status === "running").length;
  const queuedCount = pendingRuns.length - runningCount;
  return {
    total: pendingRuns.length,
    runningCount,
    queuedCount,
    text: [
      runningCount ? `${runningCount} executando` : null,
      queuedCount ? `${queuedCount} na fila` : null
    ].filter(Boolean).join(" · ") || "Sem itens pendentes"
  };
}

export function promptQueueRefreshInterval(runs = [], options = {}) {
  const { hasActiveActionJobs = false } = options;
  if (promptQueueSummary(runs).total > 0) return 1200;
  if (hasActiveActionJobs) return 2500;
  return 8000;
}

export function buildPromptQueue(runs = []) {
  return sortPendingPromptRuns(runs)
    .map((run, index) => {
      const mode = promptMode(run.mode);
      return {
        id: run.id,
        queuePosition: index + 1,
        status: run.status,
        statusLabel: run.status === "running" ? "Executando" : "Na fila",
        mode,
        modeLabel: mode === "plan" ? "Plano" : "Editar",
        promptPreview: previewText(run.prompt),
        createdAt: run.created_at
      };
    });
}
